import { Auction } from '@/api';
import If, { Else, ElseIf } from '@/components/util/IF';
import useItemContext from '@/hooks/useItemContext';
import i18next from 'i18next';
import Link from 'next/link';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

type Props = {
    isEverythingLoaded: boolean;
    pickupOption: Auction.FulfillmentEnum | undefined;
};

const ProductEcomProductTitle = ({ isEverythingLoaded, pickupOption }: Props) => {
    const { item: product } = useItemContext();
    return (
        <If condition={!isEverythingLoaded}>
            <Skeleton width={410} height={54} className="mb-4" />
            <Else>
                <h1 className={`text-[40px] leading-[40px] font-heading font-[300] ${(pickupOption) ? 'mb-2' : 'mb-4'} text-center md:text-left max-w-[615px]`}>
                    {product ? product.name : ''}
                </h1>
                <If condition={product?.short_description}>
                    <h2 className="text-sm text-blue12 mb-[20px]">{product?.short_description}</h2>
                </If>
                <If condition={pickupOption === Auction.FulfillmentEnum.Pickup}>
                    <div className="text-sm mb-2"><Link prefetch={false} className="underline" href="#pickup_options">{i18next.t('common:item-text.local-pickup')}</Link></div>
                    <ElseIf condition={pickupOption === Auction.FulfillmentEnum.PickupShip}>
                        <div className="text-sm mb-2"><Link prefetch={false} className="underline" href="#pickup_options">{i18next.t('common:item-text.local-pickup-or-ship')}</Link></div>
                    </ElseIf>
                </If>
            </Else>
        </If>
    );
};

export default ProductEcomProductTitle;
